import { OrderFormComponent } from '../components/CoffeeComponents/CRM/order-management/order-form/order-form.component';
import { Injectable } from '@angular/core';
import { QuickLinkNewPoComponent } from '../layouts/quick-links/links/quick-link-new-po/quick-link-new-po.component'
import { QuickLinkSearchPoComponent } from '../layouts/quick-links/links/quick-link-search-po/quick-link-search-po.component'

@Injectable({ providedIn: 'root' })
export class UserPreferenceService {
  getUserQuickLinks() {
    return [
      { label: 'Create Order', icon: 'add_shopping_cart', description: 'Create a customer sales order', component: OrderFormComponent, pulldown: true },
      { label: 'New PO', icon: 'add_circle_outline', description: 'Create a single or spread purchase order', component: QuickLinkNewPoComponent },
      { label: 'PO Search', icon: 'search', description: 'Find a purchase order or reference', component: QuickLinkSearchPoComponent }
    ];
  }
}
